import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import "./GetStarted.css";
import get_started_1 from "../../Assets/svgs/updated_get_started_1.svg";
import get_started_2 from "../../Assets/svgs/updated_get_started_2.svg";
import get_started_3 from "../../Assets/svgs/updated_get_started_3.svg";
import get_started_4 from "../../Assets/svgs/get_started_4.svg";
import get_started_5 from "../../Assets/Images/get_started_5.png";
import prevIcon from "../../Assets/svgs/arrow-button-left.svg";  
import nextIcon from "../../Assets/svgs/arrow-button-right.svg";  

const slides = [
  { src: get_started_1, title: "Step 1: Signup", alt: "Step 1: Sign up to Boost Board digital signage solution" },
  { src: get_started_5, title: "Step 2 : Install Boostboard app on your TV", alt: "Step 2: Install Boostboard app" },
  { src: get_started_2, title: "Step 3: Link Screen", alt: "Step 3: Link Boost Board" },
  { src: get_started_3, title: "Step 4: Upload Media", alt: "Step 4: Upload media in CMS" },
  { src: get_started_4, title: "Step 5: Display", alt: "Step 5: Digital signage screen showing company offers" },
];

const GetStarted = () => {
  const [index, setIndex] = useState(0);

  const goToNextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const goToPrevSlide = () => {
    setIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  return (
    <section id="idealfor">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title">
              <h2 className="first_text">
                Turn your <span className="second_text">digital screens</span> into billboards today
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{ paddingBlock: "1px" }}>
        <div className="row">
          <div className="col-sm-12">
            <div className="card_carousal">
              <Carousel
                activeIndex={index}
                onSelect={setIndex}
                indicators={false}
                controls={false}
                fade
                interval={null}
              >
                {slides.map((slide, i) => (
                  <Carousel.Item key={i} className={`carousel-item ${index === i ? "active" : "hidden-slide"}`}>
                    <h2 className="slide-text">{slide.title}</h2>
                    <img className="slide-image" src={slide.src} alt={slide.alt} />
                  </Carousel.Item>
                ))}
              </Carousel>
              <div className="buttons-container">
              <button className="nav-button prev-button arrow-button" onClick={goToPrevSlide}>
                <img src={prevIcon} alt="Previous" />
              </button>
              <button className="nav-button next-button arrow-button" onClick={goToNextSlide}>
                <img src={nextIcon} alt="Next" />
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
